import React from 'react';
import * as S from './Badge.styles';
const Badge = /*#__PURE__*/React.forwardRef(({
  size = 'medium',
  text,
  number
}, ref) => {
  const hasNumber = number !== undefined;
  return hasNumber && !text ? /*#__PURE__*/React.createElement(S.BadgeNumber, {
    $isAlone: true,
    $size: size,
    number: number
  }, number) : /*#__PURE__*/React.createElement(S.BadgeWrapper, null, /*#__PURE__*/React.createElement(S.BadgeContainer, {
    ref: ref,
    $size: size
  }, hasNumber ? /*#__PURE__*/React.createElement(S.BadgeNumber, {
    $size: size,
    number: number
  }, number) : null, !!text ? /*#__PURE__*/React.createElement(S.BadgeText, {
    $size: size
  }, text) : null));
});
export { Badge };